import axios from 'axios'

// O painel usa cookies HttpOnly para a sessão administrativa e um token
// CSRF mantido apenas durante a aba atual. O Bearer token continua aceito
// para clientes móveis e ferramentas de integração existentes.

const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  import.meta.env.REACT_APP_API_URL ||
  'http://localhost:8000'

export const getAdminCsrfToken = () => sessionStorage.getItem('admin-csrf') || ''

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para adicionar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    const csrfToken = getAdminCsrfToken()
    if (csrfToken && !['get', 'head', 'options'].includes(config.method?.toLowerCase())) {
      config.headers['X-CSRF-Token'] = csrfToken
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config
    const isAdminAuthRequest = original?.url?.startsWith('/auth/admin/')
    if (error.response?.status === 401 && original && !original._retry && !isAdminAuthRequest) {
      original._retry = true
      try {
        const response = await axios.post(`${API_BASE_URL}/auth/admin/refresh`, {}, {
          withCredentials: true,
          headers: { 'X-CSRF-Token': getAdminCsrfToken() },
        })
        sessionStorage.setItem('admin-csrf', response.data.csrf_token)
        original.headers['X-CSRF-Token'] = response.data.csrf_token
        return api(original)
      } catch {
        sessionStorage.removeItem('admin-csrf')
      }
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('auth-storage')
      sessionStorage.removeItem('admin-csrf')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
